import { BsPencil } from 'react-icons/bs'
import TableButton from './TableButton'
import { Dropdown, IDropdownItem } from 'components/UI/Dropdown/Dropdown'
import React from 'react'

export default function TableButtonAction({
  selectedRowsCount,
  items,
}: {
  selectedRowsCount: number
  items?: IDropdownItem[]
} & Partial<React.ComponentProps<typeof TableButton>>) {
  if (selectedRowsCount === 0) {
    return null
  }

  return (
    <Dropdown
      className={'mt-2'}
      buttonIcon={<BsPencil size={20} />}
      buttonLabel="Actions"
      buttonVariant="primary"
      items={items ?? []}
      menuLabel={`Apply to all ${selectedRowsCount} row${
        selectedRowsCount > 1 ? 's' : ''
      }`}
      disabled={selectedRowsCount === 0}
    />
  )
}
